import {LoadingMessage} from '../session-logs/LoadingMessage'
import {LoadingMessage as ProgressLoadingMessage} from '@github-ui/agent-sessions-interface/components/LoadingMessage'
import type {ReactNode} from 'react'
import {useSessionLoadingPresentation} from '../../hooks/use-session-loading-presentation'

export function SessionLoadingIndicator({preparationVisual}: {preparationVisual?: ReactNode}) {
  const presentation = useSessionLoadingPresentation()
  if (!presentation) return null

  return (
    <div id={presentation.descriptionId} data-testid="session-loading-indicator">
      {presentation.kind === 'preparation' ? preparationVisual : null}
      {presentation.progress !== undefined ? (
        <ProgressLoadingMessage message={presentation.message} progress={presentation.progress} />
      ) : (
        <LoadingMessage message={presentation.message} />
      )}
    </div>
  )
}
